import { createContext, useContext, useState } from "react";

import styled from "styled-components/macro";

import classNames from "classnames";
import { motion } from "framer-motion";

export const FnrScreenContext = createContext();

export function FnrScreen({
  children,
  show,
  side,
  height,
  style,
  onAnimationInComplete,
  onAnimationOutComplete,
}) {
  const [isAnimatedIn, setIsAnimatedIn] = useState(show);
  const [isAnimatedOut, setIsAnimatedOut] = useState(!show);

  const showChild = {
    x: 0,
    position: "relative",
    opacity: 1,
    transition: { delay: 0.05 },
  };

  const hideChild = {
    position: "absolute",
    opacity: 0,
    x: side === "left" ? -40 : 40,
    transition: { type: "tween", duration: 0.2, ease: "easeOut" },
  };

  const context = { show, isAnimatedIn, isAnimatedOut };

  const onAnimationComplete = () => {
    if (show) {
      setIsAnimatedIn(true);
      setIsAnimatedOut(false);
      if (onAnimationInComplete) onAnimationInComplete();
    } else {
      setIsAnimatedIn(false);
      setIsAnimatedOut(true);
      if (onAnimationOutComplete) onAnimationOutComplete();
    }
  };

  return (
    <FnrScreenContext.Provider value={context}>
      <ScreenWrapper
        className={classNames({ hidden: !show })}
        style={style}
        $height={height}
      >
        <Animator
          initial={show ? showChild : hideChild}
          animate={show ? showChild : hideChild}
          onAnimationComplete={onAnimationComplete}
          $height={height}
        >
          {children}
        </Animator>
      </ScreenWrapper>
    </FnrScreenContext.Provider>
  );
}
const Animator = styled(motion.div)`
  width: 100%;
  position: relative;
  height: ${(p) => (p.$height ? p.$height : "100%")};
`;
const ScreenWrapper = styled.div`
  transition: visibility 0.5s;
  height: ${(p) => (p.$height ? p.$height : "100%")};

  &.hidden {
    visibility: hidden;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
  }
`;

export const FnrScreensContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const useFnrScreen = () => {
  const context = useContext(FnrScreenContext);
  if (!context) {
    throw new Error(
      "useFnrScreen must be used within a FnrScreenContext.Provider"
    );
  }

  return context;
};
